import { render, staticRenderFns } from "./failure.vue?vue&type=template&id=766a73ef&scoped=true&lang=pug"
import script from "./failure.vue?vue&type=script&lang=js"
export * from "./failure.vue?vue&type=script&lang=js"
import style0 from "./failure.vue?vue&type=style&index=0&id=766a73ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a73ef",
  null
  
)

export default component.exports